<template lang="pug">
  .legend__group
    div(
      :class="className"
    )
      div.legend__name.semibold {{$translate('Поиск МСиН')}}
    .legend__small-group
      .search-block
        input.search-block__input.input(
          type="search"
          placeholder="Наименование"
          v-model="query"
          v-debounce:300="searchMsn")
    .legend__lists
      ul.search-block__list.reset-list(
        v-if="list.length"
      )
        li.search-block__item.type(
          v-for="item in list" :key="'list'+item.id"
        )
          .custom-checkbox
            label.custom-checkbox__label.label
              input.visually-hidden.custom-checkbox__input(
                type="checkbox"
                v-model="item.checked"
                @change="(event) => checkItem(event, item)"
              )
              span.custom-checkbox__block
              span.custom-checkbox__text {{item.name}} {{item.address}}
      ul.search-block__list.search-block__list_checked.reset-list(
        v-if="checkedList.length"
      )
        li.search-block__item(
          v-for="item in checkedList" :key="'checked-'+item.id"
        )
          span {{item.name}} {{item.address}}
          button.search-block__delete.reset-btn(
            @click="() => deleteFromList(item.id)"
          )
</template>

<script>
import { msn, transport } from '@/api/api-endpoints'
import SearchMapMixin from '@/mixins/search-map-mixin'

export default {
  name: 'map-msn',
  mixins: [SearchMapMixin],
  props: {
    className: {
      type: String,
      default: 'legend__type legend__type_with-small',
    },
    customQuery: {
      type: Object,
      default: null,
    },
    isMsnTransportSearch: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    msns() {
      return this.$store.getters.readUrlEndpoint(msn.addresses())
    },
  },
  methods: {
    async searchMsn(query) {
      if (query) {
        let endpoint = msn.containers(
          { query: { q: query, ...this.customQuery } },
          'with_containers'
        )
        if (this.isMsnTransportSearch) {
          endpoint = transport.waybillsMsns({
            query: { q: query, ...this.customQuery },
          })
        }
        this.list = await (
          await this.$store.dispatch('updateUrlEndpoint', {
            endpoint,
          })
        ).data.data
      } else {
        this.list = []
      }
    },
  },
}
</script>
